import { COOKIE_PATH, ECookies } from './types';
import Cookies from 'js-cookie';

const cookieOptions = { path: COOKIE_PATH };

export const clearCookies = () => {
  Cookies.remove(ECookies.TOKEN, cookieOptions);
  Cookies.remove(ECookies.REFRESH_TOKEN, cookieOptions);
  Cookies.remove(ECookies.TOKEN_EXPIRES_IN, cookieOptions);
  Cookies.remove(ECookies.TOKEN_TYPE, cookieOptions);
};

export const setCookieSafely = (name: ECookies, value: string) => {
  Cookies.remove(name, cookieOptions);
  Cookies.set(name, value, cookieOptions);
};
